// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { externalTestPartnerId } from './ExternalTestPartner';
import { testSessionId } from './TestSession';
import { testResultImportSourceEnum } from './TestResultImportSourceEnum';
import { fileStorageId } from './FileStorage';
import { testResultImportStatusEnum } from './TestResultImportStatusEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const testResultImportId = (z.number());
export const testResultImport = z.object({
    id: testResultImportId,
    external_test_partner_id: externalTestPartnerId,
    test_session_id: testSessionId.nullable(),
    source: testResultImportSourceEnum,
    file_storage_id: fileStorageId,
    status: testResultImportStatusEnum,
    extraction: z.unknown().nullable(),
    review_state: z.unknown().nullable(),
    error: z.string().nullable(),
    committed_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    sheet_name: z.string().nullable(),
});
export const testResultImportInitializer = z.object({
    id: testResultImportId.optional(),
    external_test_partner_id: externalTestPartnerId,
    test_session_id: testSessionId.optional().nullable(),
    source: testResultImportSourceEnum,
    file_storage_id: fileStorageId,
    status: testResultImportStatusEnum.optional(),
    extraction: z.unknown().optional().nullable(),
    review_state: z.unknown().optional().nullable(),
    error: z.string().optional().nullable(),
    committed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    sheet_name: z.string().optional().nullable(),
});
export const testResultImportMutator = z.object({
    id: testResultImportId.optional(),
    external_test_partner_id: externalTestPartnerId.optional(),
    test_session_id: testSessionId.optional().nullable(),
    source: testResultImportSourceEnum.optional(),
    file_storage_id: fileStorageId.optional(),
    status: testResultImportStatusEnum.optional(),
    extraction: z.unknown().optional().nullable(),
    review_state: z.unknown().optional().nullable(),
    error: z.string().optional().nullable(),
    committed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    sheet_name: z.string().optional().nullable(),
});
//# sourceMappingURL=TestResultImport.js.map